<template>
    <div class="flex items-center align-middle">
      <vx-tooltip :text="group.name" v-for="(group, gIndex) in groups" style="margin-top: 2px" :key="gIndex">
        <vs-avatar :color="group.color" :text="group.name.charAt(0).toUpperCase()" class="flex-shrink-0 mr-2"
                   size="30px"  @click="$router.push(`/a/groups/${group.id}`)"/>
      </vx-tooltip>
    </div>
</template>

<script>
export default {
  data () {
    return {
      groups: []
    }
  },
  methods: {
    fetchGroupDetails (id) {
      this.$httpc.get(`groups/${id}?cc=user_list_table_group`, {
        ttl: 15
      })
        .then(response => {

          if (response.status === 200) {
            this.groups.push(response.data.data)
          }
        })
    }
  },
  created () {
    if (this.params.value.length !== 0) {
      this.params.value.forEach(group => {
        this.fetchGroupDetails(group)
      })
    }
  }
}

</script>
